(function () {
  "use strict";

  function initZebaReviews() {
    var section = document.querySelector("[data-zeba-reviews]");
    if (!section) return;

    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) return;

    var tracks = section.querySelectorAll(".zeba-reviews__track");
    tracks.forEach(function (track) {
      track.classList.add("is-animating");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initZebaReviews);
  } else {
    initZebaReviews();
  }
})();
